import { ButtonHTMLAttributes, DetailedHTMLProps, FC, ReactNode } from 'react'
import clsx from 'clsx'
import { ButtonTypes } from '../../types/generalType'
import ButtonLoaderIcon from '../icons/ButtonLoaderIcon'

type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
type IProps = {
  types?: ButtonTypes
  children?: ReactNode
  icon?: ReactNode
  classes?: string
  loading?: boolean
}

const Button: FC<IProps & ButtonProps> = ({
  types = 'default',
  children,
  icon,
  classes,
  loading,
  ...props
}) => {
  let buttonBGColor: string | null = null
  let buttonBGHoverColor: string | null = null

  switch (types) {
    case 'default':
      buttonBGColor = 'bg-gray-300'
      buttonBGHoverColor = 'hover:bg-blue-400'
      break
    case 'success':
      buttonBGColor = 'bg-green-400'
      buttonBGHoverColor = 'hover:bg-green-500'
      break
    default:
      'default'
  }

  return (
    <button
      className={clsx(
        'px-3 py-2 rounded-lg text-sm duration-300 ease-in-out',
        types === 'default' ? 'text-gray-500 hover:text-white' : 'text-white',
        `${classes} ${buttonBGColor} ${buttonBGHoverColor}`,
        props.disabled && types === 'success' && 'bg-green-300 hover:bg-green-300',
        props.disabled && types === 'default' && 'bg-gray-300 hover:bg-gray-300',
      )}
      {...props}
    >
      {loading ? (
        <ButtonLoaderIcon />
      ) : icon ? (
        <span className='flex items-center'>
          {icon}
          <span className='text-center flex-1 mr-2'>{children}</span>
        </span>
      ) : (
        children
      )}
    </button>
  )
}

export default Button
